import { render, staticRenderFns } from "./KundendatenReservierung.vue?vue&type=template&id=19f8f212"
import script from "./KundendatenReservierung.vue?vue&type=script&lang=ts"
export * from "./KundendatenReservierung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports